import React from 'react';
import { modelClass } from '/imports/api/logPackets';
import { ModelFormPage } from '/imports/ui/ModelFormPage';

export const LogPacketPage = () => (
  <ModelFormPage
    modelClass={modelClass as any}
    permission={(user) => !!user?.isSuperUser}
    formSpec={() => [[{ field: 'runId', label: 'Run ID' }], [{ field: 'bot', label: 'Bot' }], [{ field: 'opcode', label: 'Opcode' }], [{ field: 'packet', label: 'Packet (hex)' }], [{ field: 'direction', label: 'Direction' }]]}
  />
);
